module.exports = __webpack_public_path__ + "static/p04_burroOrejaDer-8a1fff7e9e20d593ce1d514bf1524983.png";